(function () {
    angular.module('app')
        .directive('equalizerManager', equalizerManager);

    function equalizerManager() {
        var directive = {
            restrict: 'A',
            controller: equalizerManagerController,
            link: function () { },
            priority: 99
        };
        return directive;
    }

    equalizerManagerController.$inject = ['$scope', '$element', '$attrs', '$window', 'helper', '$timeout','bmgLogger'];
    function equalizerManagerController($scope, $element, $attrs, $window, helper, $timeout, bmgLogger) {
        var ctrl = this;
        ctrl.$mediaQueries = helper.getMediaQueries();
        ctrl.counts = {};
        if ($attrs.class) {
            var keys = Object.keys(ctrl.$mediaQueries);
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                var regex = new RegExp('(' + key + '\\-up\\-)(\\d+)', 'g');
                var result = regex.exec($attrs.class);
                if (result !== null) {
                    ctrl.counts[key] = parseInt(result[2]);
                }
            }
        }
        ctrl.mediaQuery = $attrs.equalizerManager ? ctrl.$mediaQueries[$attrs.equalizerManager] : $window.matchMedia('(min-width: 0px)');
        ctrl.$items = [];
        ctrl.registerEqualizer = function (index, element) {
            ctrl.$items.push(element);
            ctrl.$updateHeights();
        };

        angular.element($window).on('resize.equalizerManager', function () {
            ctrl.$updateSize();
            ctrl.$updateHeights();
        });

        ctrl.$updateSize = function() {
            var size = 0;
            ctrl.$gridSize = 9999;
            var keys = Object.keys(ctrl.$mediaQueries);
            for (var i=0; i<keys.length; i++) {
                var key = keys[i];
                size = ctrl.counts[key];
                if (size && ctrl.$mediaQueries[key].matches) {
                    ctrl.$gridSize = size;
                }
            }
        }

        ctrl.$updateHeights = function () {
            $timeout(function () {
                var itemSet = [];
                for (var i = 0; i < ctrl.$items.length; i++) {
                    if (ctrl.$items[i]) {
                        if (itemSet.length > 1 && i % ctrl.$gridSize === 0) {
                            ctrl.$calcHeights(itemSet);
                            itemSet = [];
                        }
                        itemSet.push(angular.element(ctrl.$items[i]));
                    }
                }
                if (itemSet.length > 0) {
                    ctrl.$calcHeights(itemSet);
                }
            })
        }

        ctrl.$calcHeights = function (itemSet) {
            var max = 0;
            for (var j = 0; j < itemSet.length; j++) {
                var element = itemSet[j];
                element.css({
                    height: '',
                    flex: ''
                });
                max = Math.max(element.outerHeight(), max);
            }
            console.log(max);
            if (ctrl.mediaQuery.matches && ctrl.$gridSize > 1 && itemSet.length > 1) {
                for (var j = 0; j < itemSet.length; j++) {
                    var element = itemSet[j];
                    if ($attrs.equalizerManager == 'flex') {
                        element.css('flex', '0 0 ' + max + 'px')
                    }
                    else {
                        element.css('height', max);
                    }
                }
            }
        }

        ctrl.$updateSize();
    }
})();